import { Routes, Route, Navigate, useParams } from "react-router-dom";
import { AuthProvider } from "../auth/Auth";
import PublicUserLayout from "../layouts/public-user-layout";
import { base } from "../globals/route-names";
import CmsFeBridgePage from "../utils/CmsFeBridgePage";

function AdminResetRedirect() {
  const { token } = useParams();
  return <Navigate to={`/admin/reset-password/${token}`} replace />;
}

function AdminResetAliasRedirect() {
  const { token } = useParams();
  return <Navigate to={`/admin/reset-password/${token}`} replace />;
}

function AppRoutes() {
  return (
    <AuthProvider>
      <Routes>
        {/* ── Auth redirects ──────────────────────────────────────── */}
        <Route path="/reset-password/:token" element={<AdminResetRedirect />} />
        <Route path="/invite/:token"         element={<AdminResetAliasRedirect />} />
        <Route path="/forgot/:token"         element={<AdminResetAliasRedirect />} />

        {/* ── CMS-FE (admin) ──────────────────────────────────────── */}
        <Route path="/login"   element={<CmsFeBridgePage />} />
        <Route path="/admin/*" element={<CmsFeBridgePage />} />

        {/* ── All public pages go through PublicUserLayout ─────────
            This includes: /, /subsubcategory/:id, /search,
            /blog-detail/:id, /case-study-details/:id, etc.
            See src/routing/public-user-routes.jsx for the full list. */}
        <Route path={base.PUBLIC_PRE + "/*"} element={<PublicUserLayout />} />

        {/* ── Redirects for legacy / discontinued URLs ─────────── */}
        <Route path="/admin"    element={<Navigate to="/login" replace />} />
        <Route path="/v2"       element={<Navigate to="/login" replace />} />
        <Route path="/cms-fe/*" element={<Navigate to="/login" replace />} />
        <Route path="/admin-v2" element={<Navigate to="/login" replace />} />
      </Routes>
    </AuthProvider>
  );
}

export default AppRoutes;
